export default __webpack_public_path__ + "static/media/menu_x.697b5024.svg";